export default {
    isTableShow: state => state.tableIsShow,
    isFormShow: state => state.formIsShow,

    getActions: state => state.actions,
    getRowActions: state => state.rowActions,
    getFormActions: state => state.formActions,
    getHeaderFields: state => state.headerFields
}